import $ from 'jquery';
import googleMapsLoader from './google-maps-loader';

export const events = $({});

/**
 * @param {HTMLElement} el
 * @param {google.maps.LatLng} center
 * @param {Number} zoom
 * @param {Object[]} markers
 *   @param {Number} markers[].lat
 *   @param {Number} markers[].lng
 *   @param {String} markers[].icon
 * @param {Boolean} fitBounds
 */
export const googleMaps = async ({
  el, center, zoom, markers, fitBounds = true,
}) => {
  const google = await googleMapsLoader.load();

  const map = new google.maps.Map(el, {
    zoom,
    center,
  });

  const googleMarkers = markers.map(({
    lat, lng, icon, id, name,
  }) => {
    const marker = new google.maps.Marker({
      map,
      icon,
      position: {
        lat,
        lng,
      },
      id,
      name,
    });

    const eventsToEmmit = [
      'click',
      'mouseover',
      'mouseout',
    ];

    eventsToEmmit.forEach((event) => {
      marker.addListener(event, () => {
        events.trigger(event, {
          marker,
          name,
          id,
          map,
          google,
        });
      });
    });

    return marker;
  });

  if (fitBounds) {
    const bounds = new google.maps.LatLngBounds();

    googleMarkers.forEach((marker) => {
      bounds.extend(marker.getPosition());
    });

    map.fitBounds(bounds);
  }
};
